export const FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MOVEMENTS =
  'FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MOVEMENTS';
export const GET_CABIN_CREW_TASK_SUMMARY_MOVEMENTS =
  'GET_CABIN_CREW_TASK_SUMMARY_MOVEMENTS';
export const FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MONTHLY =
  'FLAG_GETTING_CABIN_CREW_TASK_SUMMARY_MONTHLY';
export const GET_CABIN_CREW_TASK_SUMMARY_MONTHLY =
  'GET_CABIN_CREW_TASK_SUMMARY_MONTHLY';
export const CLEAR_CABIN_CREW_TASK_SUMMARY = 'CLEAR_CABIN_CREW_TASK_SUMMARY';